import { F0Box, F0Text } from '@factorialco/f0-react'

interface CompensationPlanMetricsProps {
  planId: string
  periodId: string
}

export function CompensationPlanMetrics({ planId, periodId }: CompensationPlanMetricsProps) {
  return (
    <F0Box padding="lg">
      <F0Text content={`Plan ID: ${planId}`} />
      <F0Text content={`Period ID: ${periodId}`} />
    </F0Box>
  )
}
